var _defs, _path, _circle, _circle2, _circle3, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareChatLinkIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.77 17.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke-miterlimit:10;}.cls-1,.cls-2{fill:none;stroke:#000;stroke-linecap:round;stroke-width:1.5px;}.cls-2{stroke-linejoin:round;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "chatbubble-outline",
    className: "cls-1",
    d: "M11.09,1.17c-.46-.16-.95-.28-1.45-.35-.53-.07-1.07-.09-1.61-.04C3.7,1.09.45,4.85.77,9.18c0,.02,0,.04,0,.06.08.73.24,1.45.49,2.14.19.51.42,1.01.48,1.14.06.13.1.27.11.42.01.16,0,.32-.06.47l-.74,2.68c-.02.06-.03.12-.03.18.02.2.19.35.4.34,0,0,0,0,0,0,.04,0,.08-.02.12-.03l2.66-.96c.2-.03.41,0,.58.11.05.03.1.06.15.09,1.32.73,2.82,1.05,4.32.93.97-.1,1.88-.37,2.7-.77"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 5.88,
    cy: 7.98,
    r: 1.76
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 15.26,
    cy: 2.7,
    r: 1.76
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 15.26,
    cy: 13.25,
    r: 1.76
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7.42,8.84l6.31,3.55M13.73,3.56l-6.31,3.55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareChatLinkIcon);
export default __webpack_public_path__ + "static/media/share-chat-link-icon.d593bbbb9355ab6482406cb3b0cb25cf.svg";
export { ForwardRef as ReactComponent };